import {Types} from "../../../../type/Types";

export type PlacePathJointValueObject = {
    id: bigint
    placeId: bigint
    placePathId: bigint
    isActive: boolean
    placeParticipationSuccessCount: number
    placeParticipationFailureCount: number
    placePathJointReportCount: number
    createdAt: Date
    modifiedAt: Date | null
}

export namespace PlacePathJointValueObject {
    export function construct(o: any): PlacePathJointValueObject {
        return {
            id: BigInt(o.id),
            placeId: BigInt(o.placeId),
            placePathId: BigInt(o.placePathId),
            isActive: Boolean(o.isActive),
            placeParticipationSuccessCount: Number(o.placeParticipationSuccessCount),
            placeParticipationFailureCount: Number(o.placeParticipationFailureCount),
            placePathJointReportCount: Number(o.placePathJointReportCount),
            createdAt: new Date(o.createdAt),
            modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
        }
    }

    export const description: Record<keyof PlacePathJointValueObject, string> = {
        id: 'ID',
        placeId: '쇼핑 ID',
        placePathId: '쇼핑 경로 ID',
        isActive: '활성 상태',
        placeParticipationSuccessCount: '성공',
        placeParticipationFailureCount: '실패',
        placePathJointReportCount: '신고',
        createdAt: '생성 시각',
        modifiedAt: '수정 시각',
    }
}